export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-part-loading/index.js